(function () {
  function initHotspots(scope) {
    var root = scope || document;
    var hotspots = root.querySelectorAll('.arbora-product-hotspot');

    hotspots.forEach(function (hotspot) {
      if (hotspot.dataset.arboraHotspotReady === 'true') return;
      hotspot.dataset.arboraHotspotReady = 'true';

      hotspot.addEventListener('click', function (event) {
        if (window.matchMedia('(hover: hover)').matches) return;

        if (!hotspot.classList.contains('is-active')) {
          event.preventDefault();
          root.querySelectorAll('.arbora-product-hotspot.is-active').forEach(function (activeHotspot) {
            activeHotspot.classList.remove('is-active');
          });
          hotspot.classList.add('is-active');
        }
      });
    });
  }

  function init() {
    initHotspots(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHotspots(event.target);
  });
})();
